<template>
  <div class="page-products">
    <Navigation :title="pageTitle" />
    <!-- 三级分类列表 -->
    <SubCateView
      ref="subCateView"
      :subCateList="tabList"
      @change="handleChangeSubCate"
      v-if="tabList.length>0"
    />
    <!-- 轮播图 -->
    <div
      class="banner-img"
      v-if="pageBannerImg"
      :style="{backgroundImage: `url(${pageBannerImg})`}"
    ></div>
    <!-- 左右滑动的商品列表 -->
    <div class="tabPage-swiper" :style="{top: tabPageTop}">
      <SubTabPage
        v-if="tabList.length === 0"
        :ref="`tabPage_-1`"
        :pageType="pageType"
        :pageId="pageId"
        :colNum="colNum"
        :curTabId="-1"
        :tabId="-1"
        :channel="channel"
      />
      <md-swiper
        v-if="tabList.length > 0"
        ref="productsSwiper"
        :autoplay="0"
        :is-prevent="false"
        :is-loop="false"
        :has-dots="false"
        :useNative-driver="false"
        :default-index="0"
        @before-change="handleSwiperChange"
      >
        <md-swiper-item v-for="tabItem in tabList" :key="tabItem.subCateId">
          <SubTabPage
            :ref="`tabPage_${tabItem.subCateId}`"
            :pageType="pageType"
            :pageId="pageId"
            :colNum="colNum"
            :curTabId="curTabId"
            :tabId="tabItem.subCateId"
            :channel="channel"
          />
        </md-swiper-item>
      </md-swiper>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/navigation'
import SubCateView from '@/components/subCateView'
import SubTabPage from '@/components/subTabPage'
import { Swiper, SwiperItem } from 'mand-mobile'
import { rem2px } from '@/utils/help'
export default {
  name: 'products',
  components: {
    Navigation,
    SubCateView,
    SubTabPage,
    [Swiper.name]: Swiper,
    [SwiperItem.name]: SwiperItem,
  },
  data() {
    return {
      channel: '',
      pageTitle: '',
      pageBannerImg: '',
      pageType: 'slide', // slide:轮播图商品列表, cate:分类商品列表
      pageId: '0', // 广告ID或二级分类ID
      colNum: 1, // 商品列表默认是单列显示
      curTabId: -1, // 当前三级分类ID
      tabList: [], // 三级分类列表
      tabPageTop: '0.88rem'
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      let AlivePages = ['productDetail']
      if (from.name === null || AlivePages.indexOf(from.name) === -1) {
        vm.initData()
      }
    })
  },
  methods: {
    initData() {
      this.resetTabPageData() // 重置上一次加载的tabPage页面数据
      this.channel = this.$route.query.channel || 'tbk'
      this.pageTitle = this.$route.query.title
      this.pageBannerImg = this.$route.query.bannerImg
      this.pageType = this.$route.query.type
      this.pageId = `${this.$route.query.id}`
      this.colNum = parseInt(this.$route.query.colNum || 1)
      this.curTabId = -1
      this.tabList = []
      if (this.pageType === 'cate') {
        // 先加载三级分类列表,再加载商品列表
        this.fetchTabList()
      } else {
        // 直接加载商品列表
        this.initTabPageTop()
        this.initTabPageData()
      }
    },
    /**
     * 加载三级分类列表
     */
    fetchTabList() {
      this.$http[this.channel].subCateList(this.pageId)
        .then(res => {
          if (res.data.length > 0) {
            for (let item of res.data) {
              item.name = item.subCateId
              item.label = item.subCateName
            }
            this.tabList = res.data
            this.curTabId = res.data[0].subCateId
          }
          this.$nextTick(() => {
            const subCateVM = this.$refs['subCateView']
            if (subCateVM) {
              subCateVM.init(this.curTabId) // 初始化三级分类组件
            }
          })
          this.initTabPageTop()
          this.initTabPageData()
        })
    },
    /**
     * 初始化tab页面的顶部距离
     */
    initTabPageTop() {
      const navigationH = rem2px(0.88) // 标题栏高度
      let bannerH = 0 // banner图高度
      let subCateH = 0 // 三级分类列表高度
      if (this.pageBannerImg) {
        // 存在banner图
        const winW = window.innerWidth || document.body.clientWidth
        bannerH = (winW * 300) / 750
      }
      if (this.tabList.length > 0) {
        // 存在三级分类列表
        subCateH = rem2px(0.72)
      }
      this.tabPageTop = `${navigationH + bannerH + subCateH}px`
    },
    
    /**
     * 更改三级分类ID
     */
    handleChangeSubCate(subCateId, index) {
      this.curTabId = subCateId
      this.$refs.productsSwiper.goto(index)
    },
    /**
     * swiper切换监听
     */
    handleSwiperChange(from, to) {
      this.curTabId = this.tabList[to].subCateId
      this.$refs['subCateView'].init(this.curTabId)
      this.initTabPageData()
    },
    /**
     * 重置tab页面数据
     */
    resetTabPageData() {
      const tabVM = this.getTabVM()
      if (tabVM) {
        tabVM.resetListData()
      }
    },
    /**
     * 初始化tab页面数据
     */
    initTabPageData() {
      this.$nextTick(() => {
        const tabVM = this.getTabVM()
        if (tabVM) {
          if (this.pageType === 'cate' && this.tabList.length > 0) {
            if (!tabVM.isInit) {
              tabVM.init()
            } else {
              tabVM.scroll2Pos(0)
            }
          } else {
            tabVM.init()
          }
        }
      })
    },
    /**
     * 获取tab页面的DOM元素
     */
    getTabVM() {
      if (this.pageType === 'cate' && this.tabList.length > 0) {
        const tabVM_Arr = this.$refs[`tabPage_${this.curTabId}`]
        if (tabVM_Arr && tabVM_Arr[0]) {
          return tabVM_Arr[0]
        }
        return null
      } else {
        if (this.$refs[`tabPage_${this.curTabId}`]) {
          return this.$refs[`tabPage_${this.curTabId}`]
        }
      }
    },
  },
}
</script>
<style type="text/css" lang="scss" scoped>
.page-products {
  position: relative;
  overflow: hidden;
  height: 100%;
  background-color: #fff;
  .banner-img {
    position: relative;
    width: 100%;
    padding-top: percentage(300/750);
    background: no-repeat center;
    background-size: cover;
  }
  .tabPage-swiper {
    position: absolute;
    top: 0.88rem;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
</style>
